module.exports = __webpack_public_path__ + "img/rating-b&w.66365c88.svg";